var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNl = function SvgNl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 67
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "nl_svg__a",
    width: 100,
    height: 67,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDBAMAAACYZb3pAAAAAXNSR0IB2cksfwAAAA9QTFRFrhwo5LS4////tcLZIUaLYp/rUAAAADRJREFUeJztyzEBACAMAzAmAQuzgAX8a8LCevAlf2rFSlEUZVh2XlpRFGVWTl6uoijKr/IAlgAJKn4xHf4AAAAASUVORK5CYII="
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#nl_svg__a"
  })));
};
export { SvgNl as ReactComponent };
export default __webpack_public_path__ + "35151d89ee09e489c41ff77c198496da.svg";